// extracted by mini-css-extract-plugin
export default {"Modal":"styles_Modal__VcEuy"};